import script from "./ViewHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewHome.vue?vue&type=script&setup=true&lang=ts"

import "./ViewHome.vue?vue&type=style&index=0&id=046816a2&lang=scss"

const __exports__ = script;

export default __exports__